module.exports = __webpack_public_path__ + "img/michael-dam-mEZ3PoFGs_k-unsplash.8ba7516e.jpg";